export enum EPageTab {
    UNSET = 'UNSET',
    JOBS = 'JOBS',
    MANAGEMENT_JOBS = 'MANAGEMENT_JOBS',
    INTERVIEW = 'INTERVIEW',
    SALARY = 'SALARY',
    ERROR404 = 'error404'
}
